import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FC } from "react";

import { addLoanApplication as addLoanApplicationAPI } from "api/loanApplications";
import { loanApplicationsKeys } from "api/loanApplications/queries";
import { NewLoanApplicationPayloadType } from "api/loanApplications/types";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import AddLoanApplicationForm, {
  LoanApplicationFormValues,
} from "./LoanApplicationForm";

interface NewLoanApplicationModalProps {
  isOpen: boolean;
  handleClose: () => void;
  creditEvaluationId: string;
}

const NewLoanApplicationModal: FC<NewLoanApplicationModalProps> = ({
  isOpen,
  handleClose,
  creditEvaluationId,
}) => {
  const queryCache = useQueryClient();

  const { mutateAsync: addLoanApplication, status } = useMutation(
    async (data: NewLoanApplicationPayloadType) => {
      const res = await addLoanApplicationAPI(data);
      await queryCache.invalidateQueries(loanApplicationsKeys.list());
      return res.data;
    },
  );

  const handleSubmit = async (values: LoanApplicationFormValues) => {
    const mappedValues: any = {
      ...values,
      creditEvaluation: creditEvaluationId,
    };

    await addLoanApplication(mappedValues, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader
        title="New Loan Application"
        subtitle="Add a new loan application to this credit evaluation."
      />
      <AddLoanApplicationForm
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        submitStatus={status}
      />
    </AppDialog>
  );
};

export default NewLoanApplicationModal;
